import { redirect, RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { DDE_MENU_ICONS } from '@/router/icons'
import { UserAdminUsersView } from '@/views/UserAdmin/UsersView'

export const userAdminRoutes: RouteObject[] = [
  {
    path: 'user-admin',
    label: 'Users',
    icon: DDE_MENU_ICONS.USER_ADMIN,
    platforms: [PLATFORM.DDE],
    children: [
      {
        index: true,
        loader: () => redirect('users'),
        platforms: [PLATFORM.DDE]
      },
      {
        path: 'users',
        element: <UserAdminUsersView />,
        platforms: [PLATFORM.DDE]
      }
    ]
  }
]
